import {
  GridColDef,
  GridRowParams,
  GridActionsCellItem ,
} from "@mui/x-data-grid-pro"

import { Sort } from "../../types"

export class ColumnsState {
  combinedColumns: ITableColumn[] = [];
  order: IColumnsOrder = {};
  visibility: IColumnsVisibility = {};
  customizableColumns: ITableColumn[] = [];
  columnDefinitions: GridColDef[] = [];
}

export interface ITableColumn extends GridColDef {
  default?: boolean;
  index?: number;
  hidden?: boolean;
  defaultSort?: Sort; // If defined, this field will be sorted by (first only)
  tooltip?: string | false;
  isLocked?: boolean;
  hideInColumnMenu?: boolean;
  search?: string;
  left?: number;
  total?: number;
  percentage?: string;
  isProgress?: boolean;
  isTarget?: boolean;
  // getActions?: (params: GridRowParams) => typeof GridActionsCellItem[];
}

export interface IColumnsOrder {
  [key: string]: number;
}

export interface IColumnsVisibility {
  [key: string]: boolean;
}

export enum ProgressColumnType {
  PERCENTAGE,
  COUNT
}